import styled from 'styled-components';

export const Image = styled.img`
  max-width: 100%;
  @media (min-width: 992px) {
    max-width: 985px;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  max-width: 950px;
  max-height: 460px;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);

  &:after {
    content: '';
    top: 0;
    left: 50%;
    width: 950px;
    height: 460px;
    position: absolute;
    border: 2px solid #f8f8f8;
    background-color: transparent;
    pointer-events: none;
    transform: translateX(-50%);
  }

  video,
  img {
    height: 100%;
    max-width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step1/styled.js